"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_avatar_1 = require("@campgladiator/cgui-core.atoms.avatar");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const chip_module_scss_1 = __importDefault(require("./chip.module.scss"));
const Chip = (_a) => {
    var { className = "", size = "small", emphasis = "default", type = "solid", removeIcon = false, onRemove, children, theme, icon, avatar } = _a, props = __rest(_a, ["className", "size", "emphasis", "type", "removeIcon", "onRemove", "children", "theme", "icon", "avatar"]);
    const styles = theme || chip_module_scss_1.default;
    const hasAvatar = !!avatar;
    const hasIcon = !!icon;
    const chipRef = (0, react_1.useRef)();
    const handleOnRemove = (self) => {
        !!onRemove ? onRemove() : self.remove();
    };
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(styles.chip, className), "data-size": size, "data-type": type, "data-emphasis": emphasis, ref: chipRef }, props),
        hasAvatar && react_1.default.createElement(cgui_core_atoms_avatar_1.Avatar, Object.assign({}, avatar, { size: "24px" })),
        hasIcon &&
            ((icon.type === "solid" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, { className: styles.icon, name: icon.name }))) ||
                (icon.type === "line" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { className: styles.icon, name: icon.name })))),
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: "xsmall", weight: "book", className: (0, classnames_1.default)(styles.label, {
                [styles.extraLeftMargin]: !hasAvatar && !hasIcon,
                [styles.extraRightMargin]: !removeIcon,
            }) }, children),
        removeIcon && (react_1.default.createElement("button", { className: styles.removeBtn, onClick: () => handleOnRemove(chipRef.current) },
            react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, { name: "icon-times-circle", className: styles.removeIcon })))));
};
exports.default = Chip;
//# sourceMappingURL=chip.js.map